import React, { useState, useEffect } from 'react';

const statesByColor = {
	red: [
		{
			name: 'Alabama',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/alabama-red.svg',
			id: '1'
		},
		{
			name: 'California',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/california-red.svg',
			id: '5'
		},
		{
			name: 'Florida',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/florida-red.svg',
			id: '9'
		},
		{
			name: 'Georgia',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/georgia-red.svg',
			id: '10'
		},
		{
			name: 'Idaho',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/idaho-red.svg',
			id: '12'
		},
		{
			name: 'Maine',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/maine-red.svg',
			id: '19'
		},
		{
			name: 'Massachusetts',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/massachusetts-red.svg',
			id: '21'
		},
		{
			name: 'Mississippi',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/mississippi-red.svg',
			id: '24'
		},
		{
			name: 'Montana',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/montana-red.svg',
			id: '26'
		},
		{
			name: 'New Jersey',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/new-jersey-red.svg',
			id: '30'
		},
		{
			name: 'Pennsylvania',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/pennsylvania-red.svg',
			id: '38'
		},
		{
			name: 'Tennessee',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/tennessee-red.svg',
			id: '42'
		},
		{
			name: 'Vermont',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/vermont-red.svg',
			id: '45'
		}
	],
	lightblue: [
		{
			name: 'Alaska',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/alaska-lightblue.svg',
			id: '2'
		},
		{
			name: 'Illinois',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/illinois-lightblue.svg',
			id: '13'
		},
		{
			name: 'Iowa',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/iowa-lightblue.svg',
			id: '15'
		},
		{
			name: 'Kansas',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/kansas-lightblue.svg',
			id: '16'
		},
		{
			name: 'Maryland',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/maryland-lightblue.svg',
			id: '20'
		},
		{
			name: 'Oklahoma',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/oklahoma-lightblue.svg',
			id: '36'
		},
		{
			name: 'South Dakota',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/south-dakota-lightblue.svg',
			id: '41'
		},
		{
			name: 'Virginia',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/virginia-lightblue.svg',
			id: '46'
		},
		{
			name: 'Washington',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/washington-lighblue.svg',
			id: '47'
		},
		{
			name: 'Wisconsin',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/wisconsin-lightblue.svg',
			id: '49'
		}
	],
	yellow: [
		{
			name: 'Arizona',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/arizona-yellow.svg',
			id: '3'
		},
		{
			name: 'Delaware',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/delaware-yellow.svg',
			id: '8'
		},
		{
			name: 'Louisiana',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/louisiana-yellow.svg',
			id: '18'
		},
		{
			name: 'Minnesota',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/minnesota-yellow.svg',
			id: '23'
		},
		{
			name: 'Nevada',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/nevada-yellow.svg',
			id: '28'
		},
		{
			name: 'New Hampshire',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/new-hampshire-yellow.svg',
			id: '29'
		},
		{
			name: 'New York',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/newyork-yellow.svg',
			id: '32'
		},
		{
			name: 'North Carolina',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/north-carolina-yellow.svg',
			id: '33'
		},
		{
			name: 'Oregon',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/oregon-yellow.svg',
			id: '37'
		},
		{
			name: 'South Carolina',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/south-carolina-yellow.svg',
			id: '40'
		},
		{
			name: 'Utah',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/utah-yellow.svg',
			id: '44'
		},
		{
			name: 'Wyoming',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/wyoming-yellow.svg',
			id: '50'
		}
	],
	lightgreen: [
		{
			name: 'Connecticut',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/connecticut-lightgreen.svg',
			id: '7'
		},
		{
			name: 'Hawaii',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/hawaii-lightgreen.svg',
			id: '11'
		},
		{
			name: 'Kentucky',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/kentucky-lightgreen.svg',
			id: '17'
		},
		{
			name: 'Texas',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/texas-lightgreen.svg',
			id: '43'
		}
	],
	blue: [
		{
			name: 'Colorado',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/colorado-blue.svg',
			id: '6'
		},
		{
			name: 'Michigan',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/michigan-blue.svg',
			id: '22'
		},
		{
			name: 'Missouri',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/missouri-blue.svg',
			id: '25'
		},
		{
			name: 'North Dakota',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/north-dakota-blue.svg',
			id: '34'
		},
		{
			name: 'Ohio',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/ohio-blue.svg',
			id: '35'
		},
		{
			name: 'Rhode Island',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/rhode-island-blue.svg',
			id: '39'
		}
	],
	green: [
		{
			name: 'Arkansas',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/arkansas-green.svg',
			id: '4'
		},
		{
			name: 'Indiana',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/indiana-green.svg',
			id: '14'
		},
		{
			name: 'Nebraska',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/nebraska-green.svg',
			id: '27'
		},
		{
			name: 'New Mexico',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/new-mexico-green.svg',
			id: '31'
		},
		{
			name: 'West Virginia',
			img: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/state-map/west-virginia-green.svg',
			id: '48'
		}
	]
};

const StateCta = ({ backgroundColor = '', textAlign = 'left', fontFamily = 'serif' }) => {
	const [currentState, setCurrentState] = useState('Florida');
	const [randomStates, setRandomStates] = useState([]);

	useEffect(() => {
		const fetchLocationData = async () => {
			try {
				if (window.sessionLayer?.marketingService?.getData) {
					const data = await window.sessionLayer.marketingService.getData();
					// Simply pass through whatever the marketing service gives us
					const successEvent = new CustomEvent('geoLocationSuccess', {
						detail: data
					});
					document.dispatchEvent(successEvent);
				} else {
					document.dispatchEvent(new CustomEvent('geoLocationFail'));
				}
			} catch (error) {
				console.error('Error fetching location data:', error);
				document.dispatchEvent(new CustomEvent('geoLocationFail'));
			}
		};

		const getColorFromState = (state) => {
			for (let color in statesByColor) {
				if (statesByColor[color].some((s) => s.name === state)) {
					return color;
				}
			}
			return null;
		};

		const getRandomStatesFromDifferentColors = (currentStateColor) => {
			let availableColors = Object.keys(statesByColor).filter((color) => color !== currentStateColor);
			let selectedStates = [];

			availableColors.forEach((color) => {
				let stateCandidates = statesByColor[color];
				let randomState = stateCandidates[Math.floor(Math.random() * stateCandidates.length)];
				selectedStates.push(randomState);
			});

			return selectedStates;
		};

		const injectStateData = () => {
			const currentStateData = Object.values(statesByColor)
				.flat()
				.find((state) => state.name === currentState);

			if (!currentStateData) return;

			const currentStateColor = getColorFromState(currentState);
			const randomStates = getRandomStatesFromDifferentColors(currentStateColor);

			setRandomStates([currentStateData, ...randomStates.slice(0, 5)]);
		};

		const handleGeoLocationSuccess = (event) => {
			if (event.detail?.location?.region) {
				setCurrentState(event.detail.location.region);
			}
		};

		document.addEventListener('geoLocationSuccess', handleGeoLocationSuccess);

		fetchLocationData();
		injectStateData();

		return () => {
			document.removeEventListener('geoLocationSuccess', handleGeoLocationSuccess);
		};
	}, [currentState]);

	const redirectToFpq = (state) => {
		let redirectUrl = 'https://www.hear.com/d/full_page_questionnaire/';
		const urlParams = document.location.search.slice(1);

		if (state) {
			redirectUrl += '?state=' + encodeURIComponent(state);
		}

		if (urlParams) {
			redirectUrl += state ? '&' + urlParams : '?' + urlParams;
		}

		window.location.href = redirectUrl;
	};

	const definedBackgroundColor =
		backgroundColor === 'lightblue'
			? '#f3f9ff'
			: backgroundColor === 'white'
			? '#ffffff'
			: backgroundColor === 'darkblue'
			? '#21314d'
			: backgroundColor;

	const textColor = backgroundColor === 'darkblue' ? '#ffffff' : '#000000';
	const linkColor = backgroundColor === 'darkblue' ? textColor : '#005c9e';

	const arrowColor =
		backgroundColor === 'darkblue'
			? 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/seo-website/double-arrow-white.svg'
			: 'https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/seo-website/double-arrow-blue.svg';

	const specificStyles = {
		backgroundColor: definedBackgroundColor,
		textAlign: textAlign,
		fontFamily: fontFamily === 'serif' ? 'Georgia, serif' : "'Open Sans', sans-serif",
		color: textColor
	};

	return (
		<div className="c-state-box o-flush-mobile" style={specificStyles}>
			<div className="o-row-2">
				<p
					className={backgroundColor === 'darkblue' ? 'c-state-box__title' : 'c-state-box__title-pages'}
					style={{ color: textColor }}
				>
					<span className={backgroundColor === 'darkblue' ? 'c-get-started-index' : ''}>Get started.</span> Click on
					your state below:
				</p>
			</div>
			<div className="o-row-2">
				<div className="c-state-box--flex">
					{randomStates.map((state, index) => (
						<div className="o-row-2" key={state.id}>
							<div className="c-state-box__state" onClick={() => redirectToFpq(state.name)}>
								<img
									className={index === 0 ? 'js-state-inject-shape-first' : 'js-state-inject-shape-rest'}
									src={state.img}
									alt="state"
								/>
								<p
									className={
										index === 0
											? 'c-state-box__state-name js-state-name-inject-first'
											: 'c-state-box__state-name js-state-name-inject-rest'
									}
								>
									{state.name}
								</p>
							</div>
						</div>
					))}
				</div>
			</div>
			<a className="c-state-box__copy" onClick={() => redirectToFpq('')} style={{ color: linkColor }}>
				Don’t see your state? Click here &nbsp;
				<img src={arrowColor} alt="pointing arrows" />
			</a>
		</div>
	);
};

export default StateCta;
